// extracted by mini-css-extract-plugin
export default {"icon":"IconInfo_icon__Zc84E","violet":"IconInfo_violet__ja+pE","white":"IconInfo_white__aJSqS"};